import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivable.List.IRequest;
type Response = Api.Finance.AccountReceivable.List.IResponse;
type Headers = Api.Finance.AccountReceivable.List.IHeaders;
const url = '/api/Finance/AccountReceivable';
export default async function accountReceivableListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
